import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import { useAuth } from "../context/AuthContext";

const MAIN_COLOR = "#5a5248";

export default function Enroll() {
  const { id } = useParams();
  const { user } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    document.title = "Enrollment - ERA AESTHETICS";
  }, []);

  return (
    <Page>
      <Card>
        <Title>Enrollment</Title>
        <Subtitle>
          Program: <strong>{id}</strong>
        </Subtitle>

        <Info>
          Signed in as <strong>{user?.email || "(unknown)"}</strong>
        </Info>

        <Note>
          Enrollment checkout isn’t implemented yet — but this route is now
          protected by Firebase Authentication.
        </Note>
      </Card>
    </Page>
  );
}

const Page = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 120px 20px 60px;
  background: #f9f8f6;
  color: ${MAIN_COLOR};
`;

const Card = styled.div`
  width: 100%;
  max-width: 700px;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid rgba(90, 82, 72, 0.12);
  border-radius: 24px;
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  box-shadow: 0 25px 60px rgba(0, 0, 0, 0.06);
  padding: 34px;
`;

const Title = styled.h1`
  font-family: "The Seasons", serif;
  font-size: 2.4rem;
  font-weight: 400;
  margin: 0 0 8px;
`;

const Subtitle = styled.p`
  margin: 0 0 18px;
  opacity: 0.8;
`;

const Info = styled.div`
  opacity: 0.9;
  margin-bottom: 14px;
`;

const Note = styled.p`
  opacity: 0.75;
  line-height: 1.7;
  margin: 0;
`;
